'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.Slick = void 0;
var $ = require("jquery");
require("slick-carousel");
var Slick = /** @class */ (function () {
    function Slick() {
        this.breakpoint = 480;
        if ($('#paramThisIsTopPage').length > 0) {
            $('.bulletSlickMain').not('.slick-initialized').slick({
                dots: false,
                arrows: false,
                autoplay: true,
                fade: true,
                speed: 3000,
                lazyLoad: 'progressive',
            });
            $('.bulletSlickSp').not('.slick-initialized').slick({
                dots: false,
                arrows: false,
                autoplay: true,
                fade: true,
                speed: 3000,
                lazyLoad: 'progressive',
            });
        }
        $('.bulletSlickBrand').slick({
            autoplay: true,
            centerMode: true,
            dots: false,
            slidesToShow: 1,
            variableWidth: true,
            appendArrows: $('.slick'),
            prevArrow: '<span class="slide-arrow slick__prev-arrow"><i class="fas fa-chevron-left"></i></span>',
            nextArrow: '<span class="slide-arrow slick__next-arrow"><i class="fas fa-chevron-right"></i></span>'
        });
    }
    return Slick;
}());
exports.Slick = Slick;
exports.default = Slick;
